import styled from 'styled-components';
import { space } from 'shared';

export const NotificationTimeAgoContent = styled.div`
  display: flex;
`;

export const TimeUnit = styled.div`
  padding-left: ${space(2)};
`;
